import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const ProjectSingle = () => {

  // Get Project details passed via router state
  const location = useLocation();
  const project = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={project.title} page={"Project Single"} />

      <section className='project-single page-single'>

        <div className='project-info page-info'>

          {/* Project Image */}
          <div className='image'>
            <img src={project.image} alt={project.title} />
          </div>

          <div className='content'>

            {/* Project Title */}
            <h3 className='main-heading'>{project.title}</h3>

            {/* Project Description */}
            {project.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Project Image Gallery */}
            <Lightbox images={project.gallery} />

            {/* Objectives & Goals Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Objectives & Goals:</h3>
              <p>Key aims and intended outcomes for {project.title} within the community.</p>

              {/* List of Objectives */}
              <ul>
                {project.objectives.map((objective, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{objective}</li>
                })}
              </ul>

            </div>

            {/* Community Impacts Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Community Impacts:</h3>
              <p>Positive effects and benefits of {project.title} on the local community.</p>

              {/* Community Impacts List */}
              <ul>
                {project.impacts.map((impact, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{impact}</li>
                })}
              </ul>

            </div>

            {/* Progress & Updates Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Progress & Updates:</h3>
              <p>Steps taken and progress made during the implementation of {project.title}.</p>

              {/* Progress & Updates */}
              <ul>
                {project.progress.map((item, index) => {
                  return <li key={index}><FaCheck className='icon' />{item}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Project details */}
        <PageSidebar
          heading={'Project'}
          details={project.details}
        />

      </section>

    </> 
  );
}

export default ProjectSingle;